import React, { useState, useEffect, useCallback } from "react";
import { Box, Button, Chip, IconButton, Dialog, Slide, Typography, Paper } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FilterListIcon from "@mui/icons-material/FilterList";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DownloadIcon from "@mui/icons-material/Download";
import { fetchData } from "../../BaseUrl";
import DocumentForm from "./DocumentForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const fallbackDocs = [
  { id: 1, name: "Reading Assignment Q1", size: "2.4 MB", date: "Mar 10, 2025", type: "Assignment" },
  { id: 2, name: "Project Guidelines 2025", size: "1.1 MB", date: "Mar 12, 2025", type: "Guidelines" },
  { id: 3, name: "Grammar Instructions", size: "890 KB", date: "Mar 14, 2025", type: "Instructions" },
  { id: 4, name: "Writing Assignment Q2", size: "3.2 MB", date: "Apr 01, 2025", type: "Assignment" },
  { id: 5, name: "Speaking Guidelines", size: "500 KB", date: "Apr 05, 2025", type: "Guidelines" },
  { id: 6, name: "Oral Exam Instructions", size: "750 KB", date: "Apr 10, 2025", type: "Instructions" },
  { id: 7, name: "Homework Template", size: "1.8 MB", date: "Apr 15, 2025", type: "Assignment" },
];

const typeStyle = (type) => {
  if (type === "Assignment") return { backgroundColor: "#e3f2fd", color: "#1976d2" };
  if (type === "Guidelines") return { backgroundColor: "#e8f5e9", color: "#4caf50" };
  return { backgroundColor: "#fff3e0", color: "#f57c00" };
};

const actionBtnStyle = {
  border: "1px solid #D5D7DA",
  borderRadius: "8px",
  color: "#8F95B2",
  textTransform: "none",
  fontSize: "13px",
  padding: "6px 14px",
};

export default function DocumentPlaceholder() {
  const [docs, setDocs] = useState([]);
  const [formOpen, setFormOpen] = useState(false);

  const loadData = useCallback(async () => {
    try {
      const response = await fetchData("admin/document/list");
      if (response?.data && Array.isArray(response.data)) {
        setDocs(response.data);
      } else {
        setDocs(fallbackDocs);
      }
    } catch (_) {
      setDocs(fallbackDocs);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <Box sx={{ padding: "1rem", textAlign: "left" }}>
      <p style={{ color: "rgba(0,0,0,0.5)", fontWeight: "bold", fontSize: "14px", margin: 0 }}>
        Pages / Document Placeholder
      </p>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1, mb: 2, flexWrap: "wrap", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <h2 style={{ margin: 0 }}>Student Management</h2>
          <Chip label="105 Students" size="small" sx={{ backgroundColor: "#e8f5e9", color: "#4caf50", fontWeight: "bold", fontSize: "12px", borderRadius: "20px", padding: "4px 12px" }} />
        </Box>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <Button startIcon={<DeleteOutlineIcon />} sx={actionBtnStyle}>Delete</Button>
          <Button startIcon={<FilterListIcon />} sx={actionBtnStyle}>Filters</Button>
          <Button startIcon={<FileDownloadIcon />} sx={actionBtnStyle}>Export</Button>
          <Button startIcon={<AddIcon />} onClick={() => setFormOpen(true)} sx={{ background: "linear-gradient(90deg,#4A7BA8,#244C77)", color: "#fff", textTransform: "none", borderRadius: "8px", padding: "8px 20px", fontSize: "13px" }}>
            Upload File
          </Button>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {docs.map((doc, idx) => (
          <Paper key={idx} sx={{ display: "flex", alignItems: "center", gap: 2, p: "14px 20px", borderRadius: "10px", boxShadow: "0 1px 6px rgba(0,0,0,0.06)", "&:hover": { boxShadow: "0 3px 12px rgba(0,0,0,0.1)" } }}>
            <CheckBoxIcon sx={{ color: "#4caf50", fontSize: "20px", flexShrink: 0 }} />
            <PictureAsPdfIcon sx={{ color: "#f44336", fontSize: "24px", flexShrink: 0 }} />
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontWeight: "bold", fontSize: "14px", color: "#1a1a2e" }}>{doc.name}</Typography>
              <Typography sx={{ fontSize: "12px", color: "#8F95B2" }}>{doc.size} &bull; Uploaded {doc.date}</Typography>
            </Box>
            <Chip
              label={doc.type}
              size="small"
              sx={{ ...typeStyle(doc.type), fontWeight: "bold", fontSize: "11px", borderRadius: "20px" }}
            />
            <IconButton size="small" sx={{ color: "#244C77" }}><DownloadIcon /></IconButton>
          </Paper>
        ))}
      </Box>

      <Dialog open={formOpen} onClose={() => setFormOpen(false)} TransitionComponent={Transition} fullWidth maxWidth="sm">
        <DocumentForm handleClose={() => { setFormOpen(false); loadData(); }} />
      </Dialog>
    </Box>
  );
}
